import React from 'react';

export const Heading = ({ text }: { text: string }) => <h4 className="text-3xl pb-2">{text}</h4>;
